import { render, staticRenderFns } from "./Pixel.vue?vue&type=template&id=f3d0c0fc&"
import script from "./Pixel.vue?vue&type=script&lang=js&"
export * from "./Pixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports